import {
  SET_USERS_ACTIONS,
  USERS_ACTIONS_LOADER,
  SET_USERS_ACTIONS_FILTERS,
  USERS_ACTIONS_LOADER_FILTER
} from "./actionTypes";

const initialState = {
  error: "",
  loading: false,
  countries: [],
  actionsFilters: [],
  filtersLoader: false,
  data: {
    count: 0,
    next: null,
    previous: null,
    page: 1,
    sizePerPage: 10,
    results: [],
  }
};

const UserActions = (state = initialState, action) => {
  switch (action.type) {
    case USERS_ACTIONS_LOADER_FILTER:
      return {
        ...state,
        filtersLoader: !state.filtersLoader
      }
    case SET_USERS_ACTIONS_FILTERS: 
      return {
        ...state,
        actionsFilters: action.payload
      }
    case SET_USERS_ACTIONS:
      return {
        ...state,
        data: action.payload
      }
    case USERS_ACTIONS_LOADER:
      return {
        ...state,
        loading: !state.loading
      }
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default UserActions;
